import { makeStyles } from "@material-ui/core/styles";
import { red, indigo, teal, grey, yellow } from "@material-ui/core/colors";

//****************************************************************************
// CSS della pagina
//****************************************************************************
const useStyleRCard = makeStyles((theme) => ({
  root: {
    maxWidth: 416,
    marginBottom: "2vh",
    marginRight: "2vh",
    display: "grid",
  },

  media: {
    height: 0,
    width: 416,
    paddingTop: "56.25%", // 16:9
    cursor: "pointer",
  },

  avatarRed: {
    backgroundColor: red[500],
  },
  avatarIndigo: {
    backgroundColor: indigo[200],
  },

  avatarTeal: {
    backgroundColor: teal[300],
  },

  avatarGrey: {
    backgroundColor: grey[400],
  },

  avatarYellow: {
    backgroundColor: yellow[300],
  },

  ulla: {
    paddingInlineStart: "0",
  },
  topic: {
    display: "inline",
    cursor: "pointer",
  },
  header: {
    cursor: "pointer",
  },
}), {index: 1});
//****************************************************************************

export default useStyleRCard;
